import { render, staticRenderFns } from "./task_stock.vue?vue&type=template&id=620dc82e&scoped=true"
import script from "./task_stock.vue?vue&type=script&lang=js"
export * from "./task_stock.vue?vue&type=script&lang=js"
import style0 from "./task_stock.vue?vue&type=style&index=0&id=620dc82e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620dc82e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('620dc82e')) {
      api.createRecord('620dc82e', component.options)
    } else {
      api.reload('620dc82e', component.options)
    }
    module.hot.accept("./task_stock.vue?vue&type=template&id=620dc82e&scoped=true", function () {
      api.rerender('620dc82e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/grow/task_stock.vue"
export default component.exports